/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef, useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AnimatedButton from '../../../components/Animation/AnimatedButton';
import { useSearchParams } from 'react-router-dom';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import { Link } from 'react-router-dom';
import GlobalContext from '../../../components/Context/GloablContext';
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
// import OrganizationExport from '../../ManageOrganizations/ManageOrganizationUser/OrganizationExport';
// import FilterModal from '../../../components/FilterModal';
import { handleAddFilterValues, handleSidebarPrvState } from '../../../redux/systemConfigSlice';
import FilterTemplate from './filterTemplate';
import TemplateExport from './TemplateExport';
import HelpGuideModal from '../../../components/HelpGuideModal';
import {useGetHelpGuideOrganizationQuery} from '../../../slices/patientSlice'

const TopBarTemplate = ({
    title,
    path,
    AddButton,
    handleApplyFilter,
    buttonName,
    ApplyFilter,
    setFilterValues,
    filterValues,
    initialState,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    toAddScreen,
    isExport,
    handleCheckboxChange,
    data,
    exportUsers }) => {
    const { isSideBar,setIsAdvancedSearchOpen,setIsSideBar } = useContext(GlobalContext);
    const userType = sessionStorage.getItem('user_type')
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams()
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [dateError, setdateError] = useState(false)
    const outSideClick = useRef();
    const filtervals = useSelector(state => state.systemConfigData.filterState)
    const ref = useRef()
    const ref2 = useRef()
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsorg, setQueryParamsorg] = useState('')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideOrganizationQuery(queryParamsorg, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })

    useOnClickOutside(ref, () => {
        setIsChangeStatusOpen(false)
    })

    useOnClickOutside(ref2, () => {
        setIsChangeStatusOpenxl(false)
    })

    const handleOpenFilter = () => {
        if (searchParams.get("start_date") === null && searchParams.get("end_date") === null) {
            setFilterValues({
                "start_date": '',
                "end_date": '',
            })
        } else {
            setFilterValues(filtervals)
        }
        setIsFilterOpen(!isFilterOpen)
        setdateError(false)
    }

    useEffect(() => {
        if (userType === 'admin') {
            setQueryParamsorg('type=org-list-templates');
        } else {
            setQueryParamsorg('type=org-user-list-templates');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsorg) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsorg]);
    
    // Function to handle onClick logic for searchbar open
    const handleSearchClick = () => {    
        // Store the current isSideBar state in Redux
        dispatch(handleSidebarPrvState(isSideBar));
                  
        // Update the states after storing the previous state
        setIsAdvancedSearchOpen(true);
        setIsSideBar(false);
    };

    return (
        <>
            <div className="flex justify-between items-center mb-[14px]">
                <div className='flex justify-between items-center'>
                    <h1 className="text-xl font-normal text-[#000000] min-w-max 2xl:pt-0 pt-2 self-start 2xl:self-center" >{title}</h1>
                    <span   onClick={() => setHelpGuideModel(true)} className=' ml-2 min-w-max cursor-pointer'>
                        <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                    </span> 
                </div>
                <div className='flex items-center 2xl:flex-nowrap flex-wrap justify-end'>
                    <button id='search-btn' onClick={handleSearchClick} className="ml-2.5 2xl:mb-0 mb-2.5 border border-[#972E4C] rounded-[15px] px-[13px] py-[13px]">
                        <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" className=''/>
                    </button>
                    {(ApplyFilter !== undefined && ApplyFilter) &&
                        <FilterTemplate
                            isFilterOpen={isFilterOpen}
                            setdateError={setdateError}
                            dateError={dateError}
                            setIsFilterOpen={setIsFilterOpen}
                            handleApplyFilter={handleApplyFilter}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            initialState={initialState}
                            handleOpenFilter={handleOpenFilter}
                            handleCheckboxChange={handleCheckboxChange}
                        />
                    }
                    {(isExport) && data !== undefined && data?.data?.length > 0 && <div className='2xl:mb-0 mb-2.5'>  <TemplateExport
                        exportUsers={exportUsers}
                        exportCols={exportCols}
                        setIsFilterOpen={setIsFilterOpen}
                        isColumnSelect={isColumnSelect}
                        setIsColumnSelect={setIsColumnSelect}
                        TotalCount={data?.total_count}
                    />
                    </div>}
                    {AddButton &&
                        <>{<Link to={toAddScreen} state={Object.fromEntries(searchParams)}>
                            <button type='button'
                                id="Add user"
                                className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5 
        bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] 2xl:w-[197px] 2xl:mb-0 mb-2.5`} style={{ 'width': 'max-content' }}>
                                <span className="mr-2.5"><img src="/images/add_Icon_white.svg" alt="img" /></span>
                                <span>{buttonName}</span>
                            </button>
                        </Link>}</>}
                </div>
            </div>
            {/* modal */}
            {(helpGuideModel && helpguidestatus==="fulfilled") &&
            <HelpGuideModal
                setHelpGuideModel={setHelpGuideModel}
                pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }
        </>
       
    );
}

export default TopBarTemplate;
